module.exports = __webpack_public_path__ + "static/media/judge-imas.222532f7.jpg";